import { TAB_ASSET } from "constants/paths";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { getAssetWithoutCampaignDetails, resetAssetsWithoutCampaigns } from "../actions";
import AssetsWithoutCampaignsTab, { PageParams } from "./AssetsWithoutCampaignTab";
import AssetWithoutCampaignAudience from "./AssetWithoutCampaignAudience";
import AssetWithoutCampaignDashboard from "./AssetWithoutCampaignDashboard";
import AssetsWithoutCampaignHeader from "./AssetWithoutCampaignHeader";
import AssetWithoutCampaignPreviouslySent from "./AssetWithoutCampaignPreviouslySent";
import AssetWithoutCampaignSmartSourcedContent from "./AssetWithoutCampaignSmartSourcedContent";

interface Props {}

const AssetWithoutCampaignWrapper = (props: Props) => {
  const { tab } = useParams<PageParams>();
  useEffect(() => {
    getAssetWithoutCampaignDetails();
    return () => {
      // reset asset without campaign redux store
      resetAssetsWithoutCampaigns();
    };
  }, []);

  //* fetch updated drafts when user adds new articles in the asset bar
  useEffect(() => {
    if (!tab) {
      getAssetWithoutCampaignDetails();
    }
  }, [tab]);

  useEffect(() => {
    document.body.style.overflow = "auto";
  }, []);

  return (
    <>
      <AssetsWithoutCampaignHeader />
      <AssetsWithoutCampaignsTab />
      {tab === TAB_ASSET.PREVIOUSLY_SENT ? (
        <AssetWithoutCampaignPreviouslySent />
      ) : tab === TAB_ASSET.AUDIENCE ? (
        <AssetWithoutCampaignAudience />
      ) : tab === TAB_ASSET.SOURCED_CONTENT ? (
        <AssetWithoutCampaignSmartSourcedContent />
      ) : (
        <AssetWithoutCampaignDashboard />
      )}
    </>
  );
};

export default AssetWithoutCampaignWrapper;
